import { IPhaseActionInfo } from '../users';
import { IStripeCustomerSubscriptionDataWrapper } from '../wrapper';

export enum IStripeScheduleStart {
  now = 'now',
}

export type IStripeScheduleEndBehaviour = 'cancel' | 'none' | 'release' | 'renew';

export interface IStripeSchedule {
  id: string;
  end_behavior: IStripeScheduleEndBehaviour;
  current_phase: IStripeSchedulePhase | null;
  customer: string;
  phases: IStripeSchedulePhase[];
  start_date?: IStripeScheduleStart;
  from_subscription?: string;
}

export interface IStripeSchedulePhase {
  end_date: number;
  start_date: number;
  plans: IStripeSchedulePlan[];
  coupon?: string | undefined;
  freezePhaseInfo?: IPhaseActionInfo;
  freeWeekPhaseInfo?: IPhaseActionInfo;
  isInfinite?: boolean;
}

export interface IStripeSchedulePlan {
  plan: string;
  price?: string;
  quantity?: number;
  description?: string;
}

export interface ISubscriptionAndSchedule {
  isContract: boolean;
  hasShedule: boolean;
  subscription: IStripeCustomerSubscriptionDataWrapper;
  subscriptionSchedule: IStripeSchedule | undefined;
}

export interface IFreezePhaseInfo {
  enabled: boolean;
  message: string | undefined;
  earliestStart?: Date;
  latestStart?: Date;
  earliestEnd?: Date;
  latestEnd?: Date;
}

export interface IFreeWeekPhaseInfo {
  enabled: boolean;
  message?: string;
  earliestStart?: Date;
  earliestEnd?: Date;
  latestStart?: Date;
  latestEnd?: Date;
}
